module.exports = __webpack_public_path__ + "img/phone-plus.f2e57e6e.svg";